import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4dfc1336&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4dfc1336&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfc1336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfc1336')) {
      api.createRecord('4dfc1336', component.options)
    } else {
      api.reload('4dfc1336', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4dfc1336&scoped=true", function () {
      api.rerender('4dfc1336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/editor/index.vue"
export default component.exports